import { actionTypes } from "./constants";

export const initialState = {
    data: null,   
    previousRequestSource: null,
    fetching: false
}

export const analyticsListReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_ANALYTICS_LIST_DATA:
            return {
                ...state,
                data: action.payload
            }
        case actionTypes.SET_ANALYTICS_LIST_CANCEL_TOKEN:
            return {
                ...state,
                previousRequestSource: action.previousRequestSource
            }
        case actionTypes.IS_ANALYTICS_LIST_FETCHING:
            return {
                ...state,
                fetching: action.fetching
            }
        default:
            return state;
    }
} 